﻿

/*------------------------------------*\
    #PRIVACY-POLICY
\*------------------------------------*/
window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.privacyPolicy = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {

        if ($(".js-page-identifier-privacy-policy").length) {

            var submitForm = false;

            $(".js-privacy-policy-form").on("submit", function () {
                submitForm = true;
            });

            window.onbeforeunload = function () {
                var changed = false;

                $(".js-privacy-policy-checkbox").each(function () {
                    var oldValue = $(this).data("accepted");
                    var newValue = $(this).is(":checked");

                    if (oldValue != newValue)
                        changed = true;
                });

                if (changed && !submitForm)
                    return "Vill du lämna sidan utan att spara? Om du väljer att lämna sidan kommer inte de ändringar du har gjort gällande samtycke för integritetspolicy att sparas.";
            }
        }
    };

    // Initialize module
    $(function () {
        priv.init();
    });

})();
